import { createThunklessAction } from 'thunkless';
import { avo } from '@/api/app/avo-client';
import type { UserInfo } from '@/components/subcomponents/user/user-info';

export enum UserTypes {
  TOGGLE_AUDIO_REQUEST = 'app/user/TOGGLE_AUDIO_REQUEST',
  TOGGLE_AUDIO_SUCCESS = 'app/user/TOGGLE_AUDIO_SUCCESS',
  TOGGLE_AUDIO_FAILURE = 'app/user/TOGGLE_AUDIO_FAILURE',

  DISABLE_TCR_BANNER_REQUEST = 'app/user/DISABLE_TCR_BANNER_REQUEST',
  DISABLE_TCR_BANNER_SUCCESS = 'app/user/DISABLE_TCR_BANNER_SUCCESS',
  DISABLE_TCR_BANNER_FAILURE = 'app/user/DISABLE_TCR_BANNER_FAILURE',

  SET_USER = 'app/user/SET_USER',

  PAUSE_NOTIFICATIONS_REQUEST = 'app/user/PAUSE_NOTIFICATIONS_REQUEST',
  PAUSE_NOTIFICATIONS_SUCCESS = 'app/user/PAUSE_NOTIFICATIONS_SUCCESS',
  PAUSE_NOTIFICATIONS_FAILURE = 'app/user/PAUSE_NOTIFICATIONS_FAILURE',

  RESUME_NOTIFICATIONS_REQUEST = 'app/user/RESUME_NOTIFICATIONS_REQUEST',
  RESUME_NOTIFICATIONS_SUCCESS = 'app/user/RESUME_NOTIFICATIONS_SUCCESS',
  RESUME_NOTIFICATIONS_FAILURE = 'app/user/RESUME_NOTIFICATIONS_FAILURE',
}

export interface ToggleAudioProps { userId: string }

export const setUser = (payload: { user: UserInfo }) => ({
  type: UserTypes.SET_USER as const,
  payload,
});

export const toggleAudio = ({ userId }: ToggleAudioProps) => createThunklessAction({
  type: [
    UserTypes.TOGGLE_AUDIO_REQUEST,
    UserTypes.TOGGLE_AUDIO_SUCCESS,
    UserTypes.TOGGLE_AUDIO_FAILURE,
  ] as const,
  promise: () => avo.ajax<never, { audio: boolean }>({
    method: 'PATCH',
    route: `/users/${userId}/toggle_audio`,
  }),
});

export interface PauseNotificationsProps {
  userId: string;
  snoozeUntil: string;
  muteChat: boolean;
  muteCalls: boolean;
}

export const pauseNotifications = ({
  userId, snoozeUntil, muteChat, muteCalls,
}: PauseNotificationsProps) => createThunklessAction({
  type: [
    UserTypes.PAUSE_NOTIFICATIONS_REQUEST,
    UserTypes.PAUSE_NOTIFICATIONS_SUCCESS,
    UserTypes.PAUSE_NOTIFICATIONS_FAILURE,
  ] as const,
  promise: () => avo.ajax({
    route: `/users/${userId}/pause_notifications`,
    method: 'PATCH',
    payload: { snooze_until: snoozeUntil, mute_chat: muteChat, mute_calls: muteCalls },
  }),
  meta: { snoozeUntil, muteChat, muteCalls },
});

export const resumeNotifications = (userId: string) => createThunklessAction({
  type: [
    UserTypes.RESUME_NOTIFICATIONS_REQUEST,
    UserTypes.RESUME_NOTIFICATIONS_SUCCESS,
    UserTypes.RESUME_NOTIFICATIONS_FAILURE,
  ] as const,
  promise: () => avo.ajax({
    route: `/users/${userId}/resume_notifications`,
    method: 'PATCH',
  }),
});

export const disableTcrBanner = (
  userId: any,
  bannerStep?: string,
) => createThunklessAction({
  type: [
    UserTypes.DISABLE_TCR_BANNER_REQUEST,
    UserTypes.DISABLE_TCR_BANNER_SUCCESS,
    UserTypes.DISABLE_TCR_BANNER_FAILURE,
  ] as const,
  promise: () => avo.ajax<never, { remindOfTcrDeadline: boolean, tcrBannerDismissedStep: string }>({
    route: `/users/${userId}/disable_tcr_banner.json`,
    method: 'PUT',
    payload: { banner_step: bannerStep },
  }),
});